import React, { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import {
  fetchIPAddress,
  googleLogin,
  login,
  loginTelegram,
} from "../../api/loginapi";
import { Form, Formik, Field } from "formik";
import { LoginSchema } from "../../yupSchema/loginSchema";
import { CheckIsNull } from "../../../../utils/CommonHelper";
import { useAuth } from "../AuthInit";
import { Input } from "../../../common/components/control/InputField";
import { LoginTab } from "../../enum/LoginTab";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../../../../setup/FirebaseConfig";
import { PromotionReviewModal } from "../../../common/components/PromotionReview";
import CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";

export const LoginFormTab = ({
  setSwalProps,
  setLoginTab,
  setTempAuth,
  credential,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const { saveAuth, setCurrentUser, promoShow, setPromoShow } = useAuth();
  const intl = useIntl();
  const longitude = useRef("");
  const latitude = useRef("");
  const currentLocale = localStorage.getItem("locale");
  const ipaddress = useRef("");
  const language = localStorage.getItem("locale");

  useEffect(() => {
    if (credential) {
      const decodeCredential = JSON.parse(
        CryptoJS.AES.decrypt(
          atob(decodeURIComponent(credential)),
          "279rc#!@279rc"
        ).toString(CryptoJS.enc.Utf8)
      );

      if (
        decodeCredential &&
        decodeCredential.username &&
        decodeCredential.password
      ) {
        fetchIPAddress()
          .then((res) => {
            const ipaddress = res.ip;
            localStorage.setItem("ipaddress", ipaddress);
            const queryParams = {
              username: decodeCredential.username,
              password: decodeCredential.password,
              language: intl.locale,
              fcmnotificationid: "",
              longitude: longitude.current,
              latitude: latitude.current,
              ipaddress: res.ip,
            };
            login(queryParams)
              .then((resp) => {
                setIsLoading(false);
                if (parseInt(resp.code) === 0) {
                  if (resp.registerby === "telno" && CheckIsNull(resp.telno)) {
                    setTempAuth({ ...resp });
                    setLoginTab(LoginTab.LOGIN_PHONE_AUTH_STEP_1);
                  } else {
                    saveAuth(resp);
                    setCurrentUser(resp);
                  }
                } else {
                  setSwalProps({
                    show: true,
                    icon: "error",
                    title: intl.formatMessage({ id: "error" }),
                    text: resp.message,
                  });
                }
              })
              .catch((error) => {
                setIsLoading(false);
              });
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    }
  }, [credential]);
  useEffect(() => {
    if (sessionStorage.getItem("platform") === "telegram") {
      localStorage.setItem("locale", "ms");
      const username = sessionStorage.getItem("username");
      const userid = sessionStorage.getItem("userid");
      fetchIPAddress().then((res) => {
        const ipaddress = res.ip;
        localStorage.setItem("ipaddress", ipaddress);
        const queryParams = {
          username: username,
          userid: userid,
          language: "ms",
          ipaddress: res.ip,
        };
        loginTelegram(queryParams).then((resp) => {
          saveAuth(resp);
          setCurrentUser(resp);
        });
      });
    }
  }, []);
  useEffect(() => {
    fetchIPAddress().then((res) => {
      ipaddress.ip = res.ip;
      localStorage.setItem("ipaddress", ipaddress.ip);
      if (!promoShow) {
        const modalTrigger = document.getElementById("modalTrigger");
        if (modalTrigger) {
          modalTrigger.click();
        }
        setPromoShow(true);
      }
    });
  }, []);
  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition(function (position) {
  //     longitude.current = position.coords.longitude;
  //     latitude.current = position.coords.latitude;
  //   });
  // }, []);

  const handleLanguageChange = (language) => {
    if (sessionStorage.getItem("platform") === "mobile") {
      console.log("update:language");
      localStorage.setItem("locale", language);
      // window.location.reload();
    } else {
      localStorage.setItem("locale", language);
      window.location.reload();
    }
  };

  // const googleAuthLogin = () => {
  //   setIsGoogleLoading(true);
  //   const app = initializeApp(firebaseConfig);
  //   const auth = getAuth(app);
  //   const provider = new GoogleAuthProvider();
  //   provider.addScope("https://www.googleapis.com/auth/userinfo.profile");
  //   signInWithPopup(auth, provider)
  //     .then((result) => {
  //       const user = result.user;

  //       fetchIPAddress()
  //         .then((res) => {
  //           const queryParams = {
  //             email: user.email,
  //             language: intl.locale,
  //             uid: user.uid,
  //             mediaplatform: "gmail",
  //             fcmnotificationid: "",
  //             latitude: latitude.current,
  //             longitude: longitude.current,
  //             ipaddress: res.ip,
  //           };
  //           googleLogin(queryParams)
  //             .then((resp) => {
  //               setIsGoogleLoading(false);
  //               if (parseInt(resp.code) === 0) {
  //                 saveAuth(resp);
  //                 setCurrentUser(resp);
  //               } else {
  //                 setSwalProps({
  //                   show: true,
  //                   icon: "error",
  //                   title: intl.formatMessage({ id: "error" }),
  //                   text: resp.message,
  //                 });
  //               }
  //             })
  //             .catch((error) => {
  //               setIsGoogleLoading(false);
  //             });
  //         })
  //         .catch((error) => {
  //           setIsGoogleLoading(false);
  //         });
  //     })
  //     .catch((error) => {
  //       setIsGoogleLoading(false);
  //       setSwalProps({
  //         show: true,
  //         icon: "error",
  //         title: intl.formatMessage({ id: "error" }),
  //         text: intl.formatMessage({ id: "failToLogin" }),
  //       });
  //     });
  // };

  const renderLoginComponent = () => {
    return (
      <div style={{ width: "100%", marginTop: 50 }}>
        <div style={{ width: "100%" }}>
          <Formik
            initialValues={{ username: "", userPassword: "" }}
            enableReinitialize={true}
            validationSchema={LoginSchema(intl)}
            onSubmit={(values, formikHelpers) => {
              setIsLoading(true);
              fetchIPAddress()
                .then((res) => {
                  const ipaddress = res.ip;
                  localStorage.setItem("ipaddress", ipaddress);
                  const queryParams = {
                    username: values.username,
                    password: values.userPassword,
                    language: intl.locale,
                    fcmnotificationid: "",
                    longitude: longitude.current,
                    latitude: latitude.current,
                    ipaddress: res.ip,
                  };
                  login(queryParams)
                    .then((resp) => {
                      setIsLoading(false);
                      if (parseInt(resp.code) === 0) {
                        if (
                          resp.registerby === "telno" &&
                          CheckIsNull(resp.telno)
                        ) {
                          setTempAuth({ ...resp });
                          setLoginTab(LoginTab.LOGIN_PHONE_AUTH_STEP_1);
                        } else {
                          saveAuth(resp);
                          setCurrentUser(resp);
                        }
                      } else {
                        formikHelpers.setFieldValue("userPassword", "");
                        setSwalProps({
                          show: true,
                          icon: "error",
                          title: intl.formatMessage({ id: "error" }),
                          text: resp.message,
                        });
                      }
                    })
                    .catch((error) => {
                      setIsLoading(false);
                    });
                })
                .catch((error) => {
                  setIsLoading(false);
                });
            }}
          >
            {({
              values,
              handleSubmit,
              setFieldValue,
              touched,
              errors,
              setFieldError,
            }) => (
              <Form>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    paddingTop: "2%",
                  }}
                >
                  <div
                    style={{
                      paddingLeft: "5%",
                      paddingRight: "5%",
                      width: "90%",
                      boxSizing: "border-box",
                    }}
                  >
                    <label
                      className="mb-2 text-input-label"
                      style={{ color: "white" }}
                    >
                      {intl.formatMessage({ id: "username" })}
                    </label>
                    <div className="mb-2">
                      <Field
                        name="username"
                        component={Input}
                        placeholder={intl.formatMessage({ id: "username" })}
                        autoComplete="off"
                        pattern="[a-zA-Z0-9]*"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      paddingLeft: "5%",
                      paddingRight: "5%",
                      width: "90%",
                      boxSizing: "border-box",
                    }}
                  >
                    <label
                      className="mb-2 text-input-label"
                      style={{ color: "white" }}
                    >
                      {intl.formatMessage({ id: "password" })}
                    </label>
                    <div className="mb-2">
                      <Field
                        name="userPassword"
                        component={Input}
                        placeholder={intl.formatMessage({ id: "password" })}
                        autoComplete="off"
                        type="password"
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    paddingTop: "2%",
                  }}
                >
                  <div style={{ width: "80%" }}>
                    <p
                      style={{
                        color: "white",
                        textAlign: "start",
                        fontSize: 13,
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          border: "none",
                          background: "none",
                          color: "white",
                          textDecoration: "underline",
                        }}
                        onClick={() => {
                          setLoginTab(LoginTab.FORGOT_PASSWORD_PART_1);
                        }}
                      >
                        {intl.formatMessage({ id: "forgetpassword" })}
                      </div>
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    paddingTop: "2%",
                  }}
                >
                  <button
                    type="submit"
                    disabled={isLoading}
                    style={{
                      width: "60%",
                      height: 35,
                      borderRadius: 15,
                      backgroundColor: "rgb(245, 190, 9)",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    {isLoading ? (
                      <div
                        className="spinner-border"
                        role="status"
                        style={{ scale: "0.75" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <div>
                        <span style={{ flex: 1, textAlign: "center" }}>
                          {intl.formatMessage({ id: "login" })}
                        </span>
                      </div>
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* <div style={{ margin: "10px", color: "white", textAlign: "center" }}>
            <div
              style={{
                display: "inline-block",
                width: "20%",
                verticalAlign: "middle",
                borderTop: "1px solid white",
              }}
            ></div>
            <span style={{ padding: "0 10px", fontSize: "12px" }}>
              {intl.formatMessage({ id: "or" })}
            </span>
            <div
              style={{
                display: "inline-block",
                width: "20%",
                verticalAlign: "middle",
                borderTop: "1px solid white",
              }}
            ></div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "2%",
            }}
          >
            <button
              onClick={() => googleAuthLogin()}
              style={{
                width: "60%",
                height: 35,
                borderRadius: 15,
                backgroundColor: "white",
                fontWeight: "bold",
                color: "black",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {isGoogleLoading ? (
                <div>
                  <div
                    className="spinner-border text-dark"
                    role="status"
                    style={{ scale: "0.75" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div>
                  <img
                    src={`${process.env.PUBLIC_URL}/image/google.png`}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  <span style={{ flex: 1, textAlign: "center" }}>
                    {intl.formatMessage({ id: "loginWithGoogle" })}
                  </span>
                </div>
              )}
            </button>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "0 auto",
              width: "90%",
              marginTop: 20,
              marginBottom: 20,
              padding: 5,
            }}
          >
            {currentLocale !== "ms" && (
              <img
                src={`${process.env.PUBLIC_URL}/image/my.avif?31234145132`}
                style={{ height: "30px", width: "30px", marginLeft: "10px" }}
                onClick={() => handleLanguageChange("ms")}
              />
            )}
            {currentLocale !== "en" && (
              <img
                src={`${process.env.PUBLIC_URL}/image/en.avif?21343454113`}
                style={{ height: "30px", width: "30px", marginLeft: "10px" }}
                onClick={() => handleLanguageChange("en")}
              />
            )}
            {currentLocale !== "zh" && (
              <img
                src={`${process.env.PUBLIC_URL}/image/cn.avif?5253441132`}
                style={{ height: "30px", width: "30px", marginLeft: "10px" }}
                onClick={() => handleLanguageChange("zh")}
              />
            )}
            {currentLocale !== "id" && (
              <img
                src={`${process.env.PUBLIC_URL}/image/id.avif?21314354131`}
                style={{ height: "30px", width: "30px", marginLeft: "10px" }}
                onClick={() => handleLanguageChange("id")}
              />
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ color: "white", textAlign: "center", fontSize: 13 }}>
              {intl.formatMessage({ id: "dontHaveAccount" })}{" "}
              <button
                style={{
                  cursor: "pointer",
                  border: "none",
                  background: "none",
                  color: "white",
                  textDecoration: "underline",
                  fontSize: 15,
                }}
                onClick={() => {
                  setLoginTab(LoginTab.REGISTER_OPTION);
                }}
              >
                {intl.formatMessage({ id: "signUp" })}
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div
      style={{
        backgroundColor: "transparent",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      {/* <PromotionReviewModal
        language={language}
        openfrom={"login"}
        ipaddress={ipaddress.ip}
      />
      {sessionStorage.getItem("platform") !== "telegram" && (
        <div
          id="modalTrigger"
          data-bs-toggle="modal"
          data-bs-target="#promotionReviewModal"
          style={{ display: "none" }}
        ></div>
      )} */}

      <div style={{ width: "100%" }}>{renderLoginComponent()}</div>
    </div>
  );
};
